<template>
  <div style="height: 490px;margin-left: -1px;" v-bar>
    <div>
      <div class="setting-props">
        <!-- preview part start -->
        <div class="setting-props__operations">
          <div class="setting-props__preview" v-if="spriteType !== 'setting_Lottie'" ref="preview" v-html="previewHTML">

          </div>
          <div class="setting-props__preview" v-if="spriteType === 'setting_Lottie'"
            v-show="previewLottie || previewLottieThumbnail"
            ref="previewLottie"
            @mouseenter="hoverPreviewLottie(true)"
            @mouseleave="hoverPreviewLottie(false)"
          ></div>
          <ul>
            <li v-for="(item, i) in operations" :key="i"
              @click="operationsAction(item.action); reportAnalysis(item.action)"
            >{{item.text}}</li>
          </ul>
        </div>
        <!-- preview part end -->

        <div class="setting-props__item setting-props__item--color" v-if="canPickColor && $isEditableShape(sprite.option.fileType)">
          <span>填充</span>
          <div class="color" @click="showColorPicker && showColorPicker({ whichPart: 'fill' })" :style="{backgroundColor: colorHex}"></div>
        </div>

        <div class="setting-props__item setting-props__item--color" v-if="canPickColor && $isEditableSvg(sprite.option.fileType)">
          <span style="white-space: nowrap;">{{$isEditableLine(sprite.option.fileType) ? '线条' : '边框'}}</span>
          <div class="color" @click="showColorPicker && showColorPicker({ whichPart: 'stroke' })" :style="{backgroundColor: strokeColorHex}"></div>

          <div class="dropdown">
            <el-popover
              v-model="strokeWidth.isShowOptions"
              popper-class="stroke-width-dropdown"
              placement="bottom"
              width="80"
              trigger="click"
            >
              <div class="dropdown__select" slot="reference" @mousedown.stop>
                <span>
                  {{sprite.option.strokeWidth == null ? '请选择' : sprite.option.strokeWidth}}
                </span>
                <i class="icon-dropdown-arrow" :style="{transform: strokeWidth.isShowOptions ? `rotate(180deg)` : '', transitionDuration: '0.3s'}"></i>
              </div>
              <div class="dropdown__options">
                <div
                  class="dropdown__item"
                  v-for="(item, i) in getStrokeWidthOptions()"
                  :key="i"
                  :class="{active: item.active}"
                  @click="setStrokeWidth(item)"
                >
                  <span>{{item.value}}</span>
                  <span
                    :style="`display: inline-block;
                      width: 30px;
                      height: ${item.thickness}px;
                      background-color: #9692a9;`"
                ></span>
                </div>
              </div>
            </el-popover>
          </div>
        </div>

        <!-- 图层设置项移到了其他地方 -->
        <!-- <div
          v-if="spriteType === 'setting_Lottie'"
          class="setting-props__item setting-props__item--arrange"
          v-show="isShowMotion && navType === 'characters'"
        >
          <span>图层</span>
          <div>
            <div class="arrange">
              <div class="arrange__item" v-for="(item, i) in arrange" :key="i"
                @click="arrangeAction(item.action)"
                v-analysis="ANALYSIS.arrange[item.action]"
              >
                <i :class="[`icon-layer-${item.alias}`]"></i>
                <div>{{item.text}}</div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- lottie loop part start -->
        <div
          class="setting-props__item setting-props__item--loop"
          v-if="spriteType === 'setting_Lottie' || spriteType === 'setting_Gif' || spriteType === 'setting_Video'"
        >
          <span>动效次数</span>
          <div>
            <div class="loop-counter">
              <div class="loop-counter__counter" @mousedown="stopEv($event)" @blur="stopEv($event)">
                <el-input-number
                  size="mini"
                  v-model="loop.count"
                  :disabled="loop.isLoop"
                  :min="1"
                  :max="10"
                  @change="onElementInputChange"
                  @focus="onElementInputFocus"
                  @blur="onElementInputBlur"
                  ref="inputNumber"
                ></el-input-number>
              </div>
              <div class="loop-counter__set">
                <i
                  :class="{'icon-checkbox-checked': loop.isLoop, 'icon-checkbox-empty': !loop.isLoop}"
                  @click="onClickCheckboxLoop"
                ></i>
                <span>循环</span>
              </div>
            </div>
          </div>
        </div>
        <!-- lottie loop part end -->

        <!-- video sprite part start -->
        <div
          class="setting-props__item setting-props__item--video-duration"
          v-if="spriteType === 'setting_Video' && sprite && sprite.video"
        >
          <span>时长</span>
          <video-sprite-duration
            :startTime="sprite.video.startTime"
            :cutDuration="sprite.video.cutDuration"
            :duration="sprite.video.duration"
          ></video-sprite-duration>
          <div>
            <video-sprite-cut-btn :sprite="TOOL.selectedSprite[0]"></video-sprite-cut-btn>
          </div>
        </div>
        <div
          class="setting-props__item setting-props__item--volume"
          v-if="spriteType === 'setting_Video' || (sprite && sprite.sound)"
        >
          <span
            style="white-space: nowrap; min-width: 42px; text-align: left;"
          >音量</span>
          <div>
            <slider
              :runway-size="110"
              :number-unit="''"
              :hasInput="false"
              :showCounter="false"
              @updateValue="onVolumeSliderUpdated"
              ref="volumeSliderRef"
            ></slider>
          </div>
          <div style="padding-left: 20px;">
            {{$refs.volumeSliderRef && $refs.volumeSliderRef.val}}
          </div>
        </div>
        <!-- video sprite part end -->

        <!-- transparent part start -->
        <div class="setting-props__item setting-props__item--opacity">
          <span style="white-space: nowrap;">透明度</span>
          <div>
            <slider
              :runway-size="100"
              :number-unit="'%'"
              @updateValue="onSliderValueUpdated"
              ref="sliderRef"
            ></slider>
          </div>
        </div>
        <!-- transparent part end -->

        <!-- chart part start -->
        <div class="setting-props__item setting-props__item--chart-text" v-if="spriteType === 'setting_Chart'">
          <span>文案</span>
          <div @click="toggleExtendArea" :class="isShowExtendArea ? 'editing' : ''"></div>
        </div>
        <div class="setting-props__extend-area" v-if="spriteType === 'setting_Chart'" v-show="isShowExtendArea">
          <div>
            <ct-opts></ct-opts>
          </div>
        </div>
        <div class="setting-chartType" v-if="spriteType === 'setting_Chart'">
          <label>图表样式</label>
          <switchChartType :chartFrom="chartFrom" :showMark="false"></switchChartType>
        </div>
        <!-- chart part end -->

        <!-- lottie action part start -->
        <div
          class="setting-props__item setting-props__item--motion"
          v-if="spriteType === 'setting_Lottie'"
          v-show="isShowMotion && navType === 'characters'"
        >
          <span>动作</span>

          <!-- <div style="position: absolute;left: 0;top: 300px;padding-top: 12px;"> -->
          <div style="margin-left: -20px; margin-top: 15px;">

            <!-- 组件高度 component-height 264 * 3 / 2 -->
            <!-- :component-height="176" -->
            <lottie-motion
              :is-show="isShowMotion"
              :component-height="346"
              @selectItem="onSelectLottieItem"
            >

            </lottie-motion>
          </div>
        </div>
        <!-- lottie action part end -->

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lottieMotion from './lottieMotionContent'
import ctOpts from './chartTextOptions'
import switchChartType from './switchChartType'
import getNavType from '@/components/mixins/getNavType';
import analysis from '@/components/mixins/analysis/spriteSettingPopup';
import slider from './slider';
import handleCrop from '@/components/mixins/handleCrop';
import videoSpriteDuration from './videoSpriteDuration';
import videoSpriteCutBtn from './videoSpriteCutBtn';

const noop = function () {} // 空函数
export default {
  components: {
    lottieMotion, // 角色动作选择组件
    ctOpts, // chart 文案设置组件
    switchChartType,
    slider,
    videoSpriteDuration,
    videoSpriteCutBtn
  },
  mixins: [ getNavType, analysis, handleCrop ],
  props: {
    // 是否有拾色器功能
    canPickColor: {
      type: Boolean,
      default: false
    },
    // 拾色器初始颜色
    // 注意： 此组件现在会从动画引擎获取素材的颜色，然后显示到属性设置栏中，所以`color`不起作用了
    color: {
      type: String,
      default: '#5778fb'
    },
    // 弹窗类型，setting_Chart, setting_Svg 等
    spriteType: {
      type: String,
      default: ''
    },
    // 唤出拾色器弹窗
    showColorPicker: {
      type: Function,
      default: noop
    },
    // 图层层级设置方法，从父组件传入
    arrangeAction: {
      type: Function,
      default: noop
    },

    // 控制右上方三个按钮怎么显示
    // 例如：
    // [
    //   {text: '替换', action: 'swap'},
    //   {text: '翻转', action: 'flip'},
    //   {text: '编辑', action: 'edit'}
    // ]
    ops: {
      type: Array,
      default() {
        return []
      }
    },

    // 右上方三个按钮触发的功能，从父组件传入
    operationsAction: {
      type: Function,
      default: noop
    },

    // echart生成图片的base64码，<img src="...base64..."/> >
    chartImgUrl: {
      type: String,
      default: ''
    },

    // 是否显示角色动作
    isShowMotion: {
      type: Boolean,
      default: false,
    },

    // 右侧导航
    navType: {
      type: String,
      default: 'scenes',
    },
  },
  data () {
    return {
      chartFrom: 'chartSetting',
      arrange: [
        {text: '置顶', action: 'front', alias: 'top'},
        {text: '置底', action: 'back', alias: 'bottom'},
        {text: '上移', action: 'forward', alias: 'up'},
        {text: '下移', action: 'backward', alias: 'down'}
      ],
      // chartType: 'pie',
      // operations: [
      //   {text: '替换', action: 'swap'},
      //   {text: '翻转', action: 'flip'},
      //   {text: '编辑', action: 'edit'}
      // ],
      previewHTML: '',
      previewEl: null,
      previewLottie: null,
      previewLottieThumbnail: '',
      isShowExtendArea: false,
      sprite: null,
      colorHex: '#5778fb',
      strokeColorHex: '#5778fb',
      loop: {
        count: 5,
        isLoop: false,
        oldVal: 0
      },
      strokeWidth: {
        min: 0,
        max: 10,
        isShowOptions: false
      }
    }
  },
  computed: {
    btnStyle () {
      return {
        backgroundColor: this.color
      }
    },
    operations () {
      let {ops} = this;
      if (!ops.length) {
        return [
          {text: '替换', action: 'swap'},
          {text: '翻转', action: 'flip'},
          {text: '编辑', action: 'edit'}
        ];
      }
      return ops;
    },
    // navType () {
    //   return this.getNavType();
    // },
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg'
    ])
  },

  watch: {
    previewLottieThumbnail: {
      handler (val) {
        if (val) {
          this.setPreviewLottie({
            url: val
          });
        }
      }
    },
    'sprite.option.fileType': {
      handler (val) {
        if (this.$isEditableShape(val)) {
          this.strokeWidth = {
            ...this.strokeWidth,
            min: 0,
            max: 10,
          }
        }
        if (this.$isEditableLine(val)) {
          this.strokeWidth = {
            ...this.strokeWidth,
            min: 1,
            max: 15,
          }
        }
      }
    }
  },

  created () {
    // console.log({prop: 'created'})
    const vm = this;
    this.sprite = this.SelectSprites_Msg[0];
    if (this.sprite) {
      this.previewChart();
      this.getPreviewEl();
    }
    this.$bus.on('show.' + this.spriteType, this.onPopupShow);
    this.setColor();
    this.$bus.on('updateSprite_vue', this.setColor);
    this.$bus.on('undoRedoHandle', ({type, mod} = {}) => {
      if (type === 'setLoop' && this.sprite) {
        this.loop.count = this.sprite.getLoop().numberOfLoops;
        this.loop.isLoop = this.sprite.getLoop().isLoop;
      }
      if (type === 'videoSprite.setLoop' && this.sprite) {
        this.loop.isLoop = this.sprite.getLoop().numberOfLoops;
      }
      if (type === 'videoSprite.setRepeatTimes' && this.sprite) {
        this.loop.count = this.sprite.getLoop().isLoop;
      }
    });

    this.$bus.off('spritePopup.visibilityChange', this.onPopupVisibilityChange)
    this.$bus.on('spritePopup.visibilityChange', this.onPopupVisibilityChange)

    eve.on('svg.updateSprite', this.setColor);
  },

  mounted () {
    const vm = this;
    let hdr = (ev) => {
      if (ev.target.tagName === 'INPUT') {
        return;
      }
      let arr = [].slice.call(this.$el.querySelectorAll('input'));
      arr.forEach((el) => {
        el.blur && el.blur();
      })
    };
    let popupEl = this.$el.closest('.setting-popup');
    popupEl && popupEl.removeEventListener('click', popupEl.hdr);
    popupEl && popupEl.addEventListener('click', hdr);
    popupEl.hdr = hdr

    popupEl && popupEl.addEventListener('mousedown', () => {
      vm.strokeWidth.isShowOptions = false;
    });

    // document.body.removeEventListener('click', document.body.hdr);
    // document.body.addEventListener('click', hdr);
    // document.body.hdr = hdr
    if(vm.$refs.volumeSliderRef && vm.sprite &&  vm.sprite.sound){
      vm.$refs.volumeSliderRef && vm.sprite
        && vm.$refs.volumeSliderRef.updateValFromOutside(vm.sprite.sound.volume);
      return;
    }

    vm.$refs.sliderRef && vm.sprite
      && vm.$refs.sliderRef.updateValFromOutside(vm.sprite.getTransparent());

    vm.$refs.volumeSliderRef && vm.sprite
      && vm.$refs.volumeSliderRef.updateValFromOutside(vm.sprite.video.volume);
  },

  destroyed () {
    this.$bus.off('show.' + this.spriteType, this.onPopupShow);
    this.$bus.off('updateSprite_vue', this.setColor);
    this.$bus.off('spritePopup.visibilityChange', this.onPopupVisibilityChange)
  },
  methods: {
    onSelectLottieItem ({
      lottieInstance,
      url,
    }) {
      this.previewLottie = lottieInstance;
      this.previewLottieThumbnail = url;
      if (!url) {
        this.setPreviewLottie({
          lottieInstance: lottieInstance
        });
      }
    },
    setPreviewLottie_ ({
      lottieInstance,
      shouldPlay
    } = {}) {
      lottieInstance.wrapper.style.width = '100%';
      lottieInstance.wrapper.style.height = '100%';
      let previewEl = this.$refs.previewLottie;
      if (previewEl.children.length) {
        previewEl.innerHTML = '';
      }
      previewEl.appendChild(lottieInstance.wrapper);
      shouldPlay && lottieInstance.play();

      this.$bus.once('lottieMotion.clear', () => {
        lottieInstance && lottieInstance.renderer && lottieInstance.destroy();
        lottieInstance = null;
        this.previewLottie = null;
      });
    },
    setPreviewLottie ({
      lottieInstance,
      url
    } = {}) {
      if (lottieInstance) {
        this.setPreviewLottie_({
          lottieInstance
        });
        return;
      }
      let img = this.getPreviewLottieThumbnail(url);
      let previewEl = this.$refs.previewLottie;
      if (previewEl.children.length) {
        previewEl.innerHTML = '';
      }
      previewEl.appendChild(img);
    },
    getPreviewLottieThumbnail (url, {video} = {}) {
      if (/\.mp4$/i.test(url)) {
        video = true;
      }
      let img = video ? document.createElement('video') : new Image();
      img.src = url;
      img.style.opacity = 0;
      let onLoad = () => {
        let el = img;
        let { naturalHeight, naturalWidth } = el;
        if (video) {
          naturalHeight = el.videoHeight;
          naturalWidth = el.videoHeight;
        }
        if (naturalHeight >= naturalWidth) {
          el.style.width = 'auto';
          el.style.height = '100%';
        } else {
          el.style.width = '100%';
          el.style.height = 'auto';
        }
        el.style.opacity = 1;
      }
      video ? img.addEventListener('canplay', onLoad) : img.addEventListener('load', onLoad);
      return img;
    },
    getPreviewLottieVideo (url) {

    },
    hoverPreviewLottie (flag) {
      if (flag) {
        this.setPreviewLottie_({
          lottieInstance: this.previewLottie,
          shouldPlay: true,
        });
      } else {
        this.previewLottie && this.previewLottie.stop();
        this.setPreviewLottie({
          url: this.previewLottieThumbnail
        });
      }
    },
    getPreviewEl () {
      let noPreview = this.spriteType !== 'setting_Image' &&
        this.spriteType !== 'setting_Svg' &&
        this.spriteType !== 'setting_Shape' &&
        this.spriteType !== 'setting_Gif' &&
        this.spriteType !== 'setting_Frame' &&
        this.spriteType !== 'setting_Video'

      if (
        noPreview
      ) {
        return;
      }

      let previewBoxWidth = 100;
      let previewBoxHeight = 100;
      let originEl = this.sprite.ele[0];
      let eleStyleDisplay = this.sprite.ele.css('display');
      this.sprite.ele.show();
      let clone = originEl.cloneNode(true);
      clone.removeAttribute('id');
      let whRatio = originEl.offsetWidth / originEl.offsetHeight;
      clone.style = null;

      if (whRatio <= 1) {
        clone.style.height = previewBoxHeight + 'px';
        clone.style.width = previewBoxHeight * whRatio + 'px';
      } else {
        clone.style.width = previewBoxWidth + 'px';
        clone.style.height = previewBoxWidth / whRatio + 'px';
      }

      if (this.spriteType === 'setting_Image' && this.sprite.cropBoxData && this.sprite.croppedFlag) {
        this.handleCropLite($(clone));
      }

      if (this.spriteType === 'setting_Image' && !this.sprite.croppedFlag) {
        let img = $(clone).find('img');
        img.css({
          position: '',
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          transform: 'none'
        });
      }

      if (this.spriteType === 'setting_Frame') {
        $(clone).css({
          position: 'relative'
        });
        // $(clone).find('.frame-image').css({
        //   display: 'none'
        // })
      }

      this.previewEl = clone;
      this.previewHTML = clone.outerHTML;

      this.$nextTick(() => {
        if (this.spriteType === 'setting_Video') {
          // $(this.$refs.preview).find('video').on('canplaythrough', (ev) => {
          //   $(ev.target).prop('currentTime', this.sprite.video.currentTime);
          // })
          $(this.$refs.preview)
            .find('video')
            .prop('currentTime', this.sprite.video.currentTime);
        }

        if (!this.sprite.croppedFlag) {
          let $preview = $(this.$refs.preview);
          let mock = $preview.find('.crop-inner-ref');
          mock.parent().children().show();
          mock.remove();
        }
      })

      if (this.sprite.effect.pathAnim.target ) {
        this.sprite.ele.css({
          display: eleStyleDisplay
        })
      }
    },

    previewChart () {
      if (!this.chartImgUrl) {
        return;
      }
      let imgEl = document.createElement('img');
      imgEl.src = this.chartImgUrl;
      this.previewHTML = imgEl.outerHTML;
    },
    toggleExtendArea () {
      this.isShowExtendArea = !this.isShowExtendArea;
      this.$emit('toggleExtendArea', {
        isExtend: this.isShowExtendArea
      })
    },
    setColor() {
      let sprite = this.SelectSprites_Msg[0] || {};
      let color;
      let strokeColor;
      if (sprite.type === 'Svg') {
        color = sprite.option.fill || sprite.fill;
        strokeColor = sprite.option.stroke || sprite.stroke;
      }
      if (sprite.type === 'Shape') {
        color = sprite.option.style.color
      }
      if (sprite.type === 'Text') {
        color = sprite.font.color
      }
      this.colorHex = color || '#5778fb';
      this.strokeColorHex = strokeColor || '#5778fb';
    },
    onPopupShow ({
      component
    }) {
      const vm = this;
      this.sprite = this.SelectSprites_Msg[0];
      this.previewChart();
      this.getPreviewEl();
      if (component.spriteType === 'setting_Lottie' || component.spriteType === 'setting_Gif' || component.spriteType === 'setting_Video') {
        this.loop.isLoop = this.sprite.getLoop().isLoop;
        this.loop.count = this.sprite.getLoop().numberOfLoops;
      }

      if( vm.sprite &&  vm.sprite.sound){

        let timeoutid = setTimeout(() => {

          if(vm.$refs.volumeSliderRef){

            vm.$refs.volumeSliderRef.updateValFromOutside(vm.sprite.sound.volume);
          }
          clearTimeout(timeoutid);
        }, 20);
        return;
      }

      vm.$refs.sliderRef
        && vm.$refs.sliderRef.updateValFromOutside(vm.sprite.getTransparent());

      vm.$refs.volumeSliderRef
        && vm.$refs.volumeSliderRef.updateValFromOutside(vm.sprite.video.volume);
    },
    onPopupVisibilityChange ({
      flag,
      component
    } = {}) {
      // console.log({flag, component})
      if (!this.sprite || !flag) {
        return;
      }
      // this.setColor();
      let val = this.sprite.option.fileType;
      if (this.$isEditableShape(val)) {
        this.strokeWidth = {
          ...this.strokeWidth,
          min: 0,
          max: 10,
        }
      }
      if (this.$isEditableLine(val)) {
        this.strokeWidth = {
          ...this.strokeWidth,
          min: 1,
          max: 15,
        }
      }
    },
    onLoopInputClicked (ev) {
      let el = ev.target;
      ev.stopPropagation();
      el.focus();
    },
    onLoopInputMouseUp (ev) {
      ev.stopPropagation();
    },
    stopEv (ev) {
      ev.stopPropagation();
    },
    onElementInputChange (val, oldVal, ...args) {
      if (('' + val).trim === '' || val == null) {
        this.loop.count = this.sprite.numberOfLoops;
        // this.loop.count = this.loop.oldVal - 0;
        // this.$set(this.loop, 'count', this.loop.oldVal - 0)
        // this.$refs.inputNumber.$el.querySelector('input').value = this.loop.count;
      }
      if (val > 10 || val < 1 || val == null) {
        val = oldVal;
        return;
      }

      if (this.sprite.type === 'Video') {
        this.sprite.setRepeatTimes(val, true);
        return;
      }
      this.sprite.setLoop(val, true);
    },
    onElementInputFocus (ev) {
      this.togglePreventDefault(false);
      if (ev.target.value) {
        this.loop.oldVal = ev.target.value;
      }
    },
    onElementInputBlur (ev) {
      this.togglePreventDefault(true);
      let o = ev.target.value;
      setTimeout(() => {
        if (ev.target.value.trim() === '') {
          ev.target.value = /* o || this.loop.oldVal ||  */this.sprite.getLoop().numberOfLoops;
        }
      }, 30)
    },
    onClickCheckboxLoop () {
      let bool = !this.sprite.getLoop().isLoop;
      this.sprite.setLoop(bool, true);
      this.loop.isLoop = this.sprite.getLoop().isLoop;

      if(this.sprite.sound){
        this.reportAnalysis(bool ? 'soundSpriteOn' : 'soundSpriteOff');

      }else{

        if (this.sprite.type === 'Video') {
          this.reportAnalysis(bool ? 'videoLoopOn' : 'videoLoopOff');
          return
        }

        this.reportAnalysis(bool ? 'lottieLoopOn' : 'lottieLoopOff');
      }

    },
    onClickCounter () {
      // this.$refs.inputNumber && this.$refs.inputNumber.focus();
    },
    togglePreventDefault(val) {
      // 是否启用快捷键
      this.$store.commit('toggle_isPreventDefault', val);
    },

    onSliderValueUpdated (val, undo) {
      this.sprite.setTransparent({
        percent: val,
        undo
      });
    },

    onVolumeSliderUpdated (val, undo) {
      // console.log({volume: val, undo})
      if (!undo) {
        return;
      }
      if(this.sprite && this.sprite.sound){

        this.reportAnalysis('soundSpriteVolume');
        this.sprite.setSound({
          volume  : val,
        })
        return;
      }
      this.sprite.setVolume(val, undo);
    },

    getStrokeWidthOptions () {
      let sprite = this.sprite;
      let arr = [];
      for (let v = this.strokeWidth.min; v <= this.strokeWidth.max; v++) {
        arr.push({
          value: v,
          // thickness: v * Math.min(sprite.width / sprite.initData.width, sprite.height / sprite.initData.height)
          thickness: v,
          active: v === sprite.option.strokeWidth
        })
      };
      return arr;
    },

    toggleStrokeWidthOptions () {
      this.strokeWidth.isShowOptions = ! this.strokeWidth.isShowOptions;
    },

    setStrokeWidth (item) {
      this.TOOL.updateSprite(this.sprite.id, {
        strokeWidth: item.value
      }, null, true)
        .then(() => {
          // console.log({w: this.sprite.option.strokeWidth});
          this.$bus.emit('strokeWidthUpdated_vue', this.sprite.option.strokeWidth);
          if (this.$isEditableShape(this.sprite.option.fileType)) {
            this.$analysis({category:'material_setting_panel', action:'click_outline_width', label:'素材设置_边框粗细'});
          }
          if (this.$isEditableShape(this.sprite.option.fileType)) {
            this.$analysis({category:'material_setting_panel', action:'click_line_width', label:'素材设置_线条粗细'});
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors.scss";

.setting-props {
  padding-left: 20px;
  padding-right: 20px;
  &__preview {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 110px;
    border: dashed 1px #f0f0f8;
    >* {
      height: 100%;
    }
  }
  &__operations {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    >ul {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      width: 90px;
      >li {
        width: 90px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        color: $c3;
        border: 1px solid $c1;
        margin-top: 14px;
        cursor: default;

        &:first-child {
          margin-top: 0;
        }

        &:hover {
          color: #5779fa;
          border: 1px solid #5779fa;
          cursor: pointer;
        }
      }
    }
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 25px;
    >span {
      margin-right: 18px;
      display: inline-block;
    }

    &--color {
      > .color {
        width: 75px;
        height: 30px;
        border-radius: 4px;
        background-color: #5779fa;
        cursor: pointer;
        box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
      }
    }
    &--arrange {
      >span {
        transform: translatey(-89%);
      }
      >div {
        flex-grow: 1;
      }
    }
    &--motion {
      display: block;
      >span {
        width: 100%;
        text-align: left;
      }
    }
    &--chart-text {
      >div {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        border: solid 1px #f0f0f8;
        background-color: #fff;
        background-image: url('../../../../static/svg/edit-display.svg');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 18px 16.2px;
        cursor: pointer;
        &:hover {
          background-color: #f0f0f8;
        }
      }
      .editing {
        background-color: #f0f0f8;
      }
    }
    &--loop {
      & > span {
        transform: translateY(-89%);
      }
    }
  }

  &__extend-area {
    position: relative;
    min-height: 218px;
    margin-top: 10px;
    >div {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translatex(-50%);
    }
  }
}

.arrange {
  display: flex;
  justify-content: space-between;
  &__item {
    min-width: 2em;
    cursor: pointer;
    $path: '../../../../static/svg/';
    &:hover:nth-child(1) {
      &>i {
        background-image: url(#{$path}#{'stick-top-active.svg'});
      }
    }
    &:hover:nth-child(2) {
      &>i {
        background-image: url(#{$path}#{'stick-bottom-active.svg'});
      }
    }
    &:hover:nth-child(3) {
      &>i {
        background-image: url(#{$path}#{'move-up-active.svg'});
      }
    }
    &:hover:nth-child(4) {
      &>i {
        background-image: url(#{$path}#{'move-down-active.svg'});
      }
    }
    &:active {
      &>i {
        transform: scale(1.2);
      }
    }
    >i {
      display: block;
      margin: 0 auto;
      width: 30px;
      height: 30px;
    }
    >div {
      width: 2em;
      margin-top: 14px;
    }
  }
}

.setting-chartType {
  margin-top: 25px;
  label {
    display: block;
    text-align: left;
  }
}

.loop-counter {
  &__counter {
    display: flex;
  }
  &__input {
    width: 40px;
    height: 30px;
    border: solid 1px #f0f0f8;
    margin: 0 4px;
  }
  &__btn {
    width: 32px;
    height: 30px;
    line-height: 30px;
    background-color: #f0f0f8;
    border-radius: 4px 0px 0px 4px;
  }
  &__set {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    &>i {
      transform: translateY(2px);
      margin-right: 0.6em;
    }
  }
}

.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border: solid 1px #f0f0f8;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 80px;
    border: solid 1px #f0f0f8;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;

    & > span:nth-child(1) {
      width: 25px;
      text-align: left;
      color: #9692a9;
    }
    &:hover, &.active {
      background-color: #f0f0f8;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/popups/content/propSetting.vue